import api from "./axiosInstance";

/**
 * 🔹 Search Customers
 * GET /api/v1/customers/searchCustomers
 */
export const searchCustomers = (params = {}) => {
  return api.get("customers/searchCustomers", { params });
};

/**
 * 🔹 Get Customer by ID
 * GET /api/v1/customer/{id}
 */
export const getCustomerById = (id) => {
  return api.get(`customer/${id}`);
};
